module.exports = __webpack_public_path__ + "img/ImKlo.8828e481.png";